export default __webpack_public_path__ + "b4d7f2e60e13911eb2ebbefb73fbfb2c.jpg";